import get from 'lodash/get';
import { emitter } from '@marvelapp/react-ab-test';
import EventConstants from '../constants/EventConstants';
import InputParser from '../utils/InputParser';
import ObjectStorageService from './ObjectStorageService';
import StorageConstants from '../constants/StorageConstants';

export function formatError(error) {
  if (!error) return { message: 'Something went wrong' };
  if (error instanceof Array) return { message: get(error, '0') };
  if (error instanceof Object) return { message: get(error, 'detail') || get(error, 'message') };
  return { message: error };
}

function isObjectEmpty(value) {
  return (
    Object.prototype.toString.call(value) === '[object Object]' && JSON.stringify(value) === '{}'
  );
}

export default {
  _setWebCamera(cameraSettings) {
    cameraSettings &&
      window.eventemitter.emit(EventConstants.eventNames.WEB_CAMERA, cameraSettings);
  },
  openWebCamera(cameraSetting = {}) {
    this._setWebCamera({ ...cameraSetting, openCamera: true });
  },
  closeWebCamera(cameraSetting = {}) {
    this._setWebCamera({ ...cameraSetting, openCamera: false });
  },
  _setWebFile(fileSettings) {
    fileSettings && window.eventemitter.emit(EventConstants.eventNames.WEB_FILE, fileSettings);
  },
  openWebFile(fileSettings = {}) {
    this._setWebFile({ ...fileSettings, openFile: true });
  },
  closeWebFile(fileSettings = {}) {
    this._setWebFile({ ...fileSettings, openFile: false });
  },
  getAndSetUTMSource() {
    const source = InputParser.getUTMSource();
    if (!source) {
      return this.getUTMSource();
    }
    console.log('UTMSource: ', { source });
    ObjectStorageService.setItem(StorageConstants.UTM_SOURCE, source);
    this.updateTrackingProperties({ utm_source: source });
    return source;
  },
  getUTMSource() {
    const utmSource = ObjectStorageService.getItem(StorageConstants.UTM_SOURCE);
    if (utmSource && !isObjectEmpty(utmSource)) {
      return utmSource;
    }
    return null;
  },
  getAndSetFacebookAllDetailsFlag() {
    const fadFlag = InputParser.getFADFlag();
    const currentData = ObjectStorageService.getItem(StorageConstants.AB_FLAG) || {};
    if (currentData.fadFlag) return;
    ObjectStorageService.setItem(StorageConstants.AB_FLAG, {
      ...currentData,
      fadFlag: fadFlag === 'true' ? 'A' : 'B',
    });
  },
  getFacebookAllDetailsFlag() {
    const flags = ObjectStorageService.getItem(StorageConstants.AB_FLAG) || {};
    return get(flags, 'fadFlag', 'B');
  },
  getAndSetLanguageLandingPageFlag(language) {
    if (language) {
      ObjectStorageService.setItem(StorageConstants.LLP_FLAG, language);
      return language;
    }
    const llpFlag = InputParser.getLLPFlag();
    ObjectStorageService.setItem(StorageConstants.LLP_FLAG, llpFlag);
    return llpFlag;
  },
  getLanguageLandingPageFlag() {
    return ObjectStorageService.getItem(StorageConstants.LLP_FLAG);
  },
  updateTrackingProperties(trackingProperties) {
    const currentTrackingProperties = this.getTrackingProperties();
    const updatedTrackingProperties = {
      ...currentTrackingProperties,
      ...trackingProperties,
    };
    ObjectStorageService.setItem(StorageConstants.TRACKING_PROPERTIES, updatedTrackingProperties);
    return updatedTrackingProperties;
  },
  getTrackingProperties() {
    return ObjectStorageService.getItem(StorageConstants.TRACKING_PROPERTIES);
  },
  getABTestVariant(experimentName) {
    return emitter.getActiveVariant(experimentName);
  },
};
